<template>
  <div class="faq-container">
    <div class="faq-content">
      <AccordionGroup is-closed-by-default>
        <Accordion
          v-for="(faq, index) in faqs"
          :key="index"
          :title="faq.question"
        >
          <p>{{ faq.answer }}</p>
        </Accordion>
      </AccordionGroup>
    </div>
    <Button tag="a" href="mailto:customercare@ratandboa.com">Contact Us</Button>
  </div>
</template>

<script>
import Accordion from "@/components/AccordionV2.vue";
import AccordionGroup from "@/components/AccordionGroup.vue";
import Button from "@/components/ButtonV3.vue";
import faqs from "@/content/account-faqs.json";

export default {
  name: "FrequentlyAskedQuestions",
  components: {
    Accordion,
    AccordionGroup,
    Button,
  },
  data() {
    return {
      faqs,
    };
  },
};
</script>

<style lang="scss" scoped>
.faq-container {
  max-width: 700px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.faq-content {
  width: 100%;
  margin-bottom: 60px;
  text-align: left;
}
</style>
